import { Project } from "interfaces";

import Tag from "ui-components/Tag";

import * as flowConfig from "flows/eta-estimator/config";
import { projectIsETAEstimator } from "flows/eta-estimator/interfaces";

const ContextSummary = ({ project }: { project: Project }) => {
  if (!projectIsETAEstimator(project)) {
    return null;
  }

  const wsId = project.workspaces[0]?.workspace;

  return (
    <div className="m-1">
      <ul className="list-decimal list-inside">
        <li>
          Origin: Latitude is{" "}
          <span className="italic">
            {project.meta_data[flowConfig.ORIGIN_LAT_KEY]}
          </span>
          , and Longitude is{" "}
          <span className="italic">
            {project.meta_data[flowConfig.ORIGIN_LONG_KEY]}
          </span>
        </li>
        <li>
          Destination: Latitude is{" "}
          <span className="italic">
            {project.meta_data[flowConfig.DEST_LAT_KEY]}
          </span>
          , and Longitude is{" "}
          <span className="italic">
            {project.meta_data[flowConfig.DEST_LONG_KEY]}
          </span>
        </li>
        <li>
          Start Time:{" "}
          <span className="italic">
            {project.meta_data[flowConfig.START_TIME_KEY]}
          </span>
          ; End Time:{" "}
          <span className="italic">
            {project.meta_data[flowConfig.END_TIME_KEY]}
          </span>
        </li>
      </ul>
      {wsId && (
        <div className="flex flex-wrap">
          <Tag bgColorClass="bg-primary-main" textColorClass="text-gray-100">
            Model Built
          </Tag>
        </div>
      )}
    </div>
  );
};

export default ContextSummary;
